// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".velocity-verification-CustomFileInput-container {\n  position: relative;\n  cursor: pointer;\n}\n.velocity-verification-CustomFileInput-input {\n  bottom: 0;\n  left: 0;\n  /* This input should always be hidden.\n  Highest specificity added to prevent the host app from overriding this style by mistake */\n  display: none !important;\n  position: absolute;\n  right: 0;\n  top: 0;\n  width: 100%;\n  z-index: 1;\n}\n", ""]);
// Exports
exports.locals = {
	"container": "velocity-verification-CustomFileInput-container",
	"input": "velocity-verification-CustomFileInput-input"
};
module.exports = exports;
